import thunk from 'redux-thunk';
import { applyMiddleware, compose, createStore } from 'redux';
import { createReduxHistoryContext } from 'redux-first-history';

import rootReducer from './reducers/index';

/**
 * @param {any} initialState
 * @param {any} history
 * @returns {{ store: ReturnType<typeof createStore>, history: any }}
 */
export default function configureStore(initialState, history) {
  const { createReduxHistory, routerMiddleware, routerReducer } = createReduxHistoryContext({ history });

  const finalCreateStore = compose(
    applyMiddleware(thunk),
    // eslint-disable-next-line no-undef
    __BROWSER__ ? applyMiddleware(routerMiddleware) : (f) => f,

    typeof window === 'object' && typeof window.devToolsExtension !== 'undefined'
      ? window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__()
      : (f) => f,
  )(createStore);

  const store = finalCreateStore(rootReducer(routerReducer), initialState);

  // Not gated on __BROWSER__ (unlike routerMiddleware above): createReduxHistory
  // dispatches the initial LOCATION_CHANGE that seeds state.router.location, which
  // SSR reads (the various ssr.ts files). That initial dispatch is a plain action
  // the reducer handles without the middleware, so it works server-side too;
  // skipping it would leave state.router.location null and break SSR.
  return { store, history: createReduxHistory(store) };
}
